// GA4 event mapper
const eventMapper = {
  filterResults: "filter_results",
  orderResults: "order_results",
  errorLog: "error_log",
  responseLog: "response_log",
  validationLog: "validation_log",
  passengerSelection: "passenger_selection",
  checkoutStep: "checkout_step",
  repricing: "repricing",
  dataInit: "data_init",
  seatSelection: "seat_selection",
  ancillaryMarket: "ancillary_market",
  funnelStep: "funnel_step",
  searchResults: "search_results",
  changeProduct: "change_product",
  orderData: "order_data",
  startForm: "start_form",
  submitForm: "submit_form",
  digitalService: "digital_service",
  deeplink: "deeplink",
  tab: "tab",
  boardingPass: "boarding_pass",
  download: "download",
  promo: "promo",
  search: "search",
  accordion: "accordion",
  click: "click",
  feedback: "feedback",
  upg: "upg",
  favouriteRoute: "favourite_route",
  boundDetail: "bound_detail",
  feature: "feature",
  permissionRequest: "permission_request",
  milestone: "milestone",
  earnedMiles: "earned_miles",
  projectedMiles: "projected_miles",
  orderDetail: "order_detail"
};

export const normalizedEvent = (eventName) => {
  return eventMapper[eventName];
};
